exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".filter-search-results-text__indicator {\n  position: relative;\n  text-align: center;\n  width: 24px;\n}\n", ""]);

